export function recProps() {
  return {
    description: {
      type: Object,
      default: () => ({}),
    } 
  } 
}
